import { Stack } from "@mantine/core";
import { type FC, useState } from "react";

import { NewsPostModal, NewsPostRow } from "@/components/news/NewsPostRow.tsx";
import { type ActiveNewsPost, useActiveNews } from "@/hooks/useActiveNews.ts";
import { useIsAdmin } from "@/hooks/useIsAdmin.ts";

export const ActiveNewsRows: FC = () => {
  const { activePosts, dismiss } = useActiveNews();
  const isAdmin = useIsAdmin();
  const [openedPost, setOpenedPost] = useState<ActiveNewsPost | null>(null);

  const handleDismiss = (id: number) => {
    dismiss(id);
    setOpenedPost((current) => (current?.id === id ? null : current));
  };

  if (activePosts.length === 0) {
    return null;
  }

  return (
    <>
      <Stack gap={1} mb="md">
        {activePosts.map((post) => (
          <NewsPostRow
            key={post.id}
            post={post}
            isAdmin={isAdmin}
            onOpen={setOpenedPost}
            onDismiss={handleDismiss}
          />
        ))}
      </Stack>
      <NewsPostModal
        post={openedPost}
        isAdmin={isAdmin}
        onClose={() => setOpenedPost(null)}
        onDismiss={handleDismiss}
      />
    </>
  );
};
